﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import { NotificationType, sendNotification } from '@tk/utilities/tk.notification';

export default class KDMZBasketButton extends TKCustomElementFactory {
    quantityField?: HTMLInputElement;
    submitButton?: HTMLButtonElement;
    formular?: HTMLFormElement;
    counterWrapper?: HTMLElement;
    url: string;
    decreaser?: HTMLButtonElement;
    increaser?: HTMLButtonElement;
    counter?: HTMLInputElement;

    constructor() {
        super();
        this.quantityField = this.querySelector('[name="input_dim1"], [data-tk-input-quantity]') || undefined;
        this.submitButton = this.querySelector('[type="submit"]') || undefined;
        this.counterWrapper = this.querySelector('[data-tk-counter]') || undefined;
        this.formular = this.querySelector('form') || undefined;
        this.url = this.getAttribute('data-url') || '';
        if (this.counterWrapper) {
            this.decreaser = this.querySelector<HTMLButtonElement>('[data-tk-counter-decreaser]') || undefined;
            this.increaser = this.querySelector<HTMLButtonElement>('[data-tk-counter-increaser]') || undefined;
            this.counter = this.querySelector<HTMLInputElement>('[data-tk-input-quantity]') || undefined;
        }
    }

    connectedCallback(): void {
        if (!this.formular) throw new Error('KDMZBasketButton: Formular is missing!');
        this.registerEventListener();
        this.registerCounter();
    }

    registerCounter() {
        if (!this.decreaser || !this.increaser) return;
        const onAmountChange = this.amountChange.bind(this);
        this.pushListener({ event: 'change', element: this.counter, action: onAmountChange });
        const onDecrease = this.decrease.bind(this);
        this.pushListener({ event: 'click', element: this.decreaser, action: onDecrease });
        const onIncrease = this.increase.bind(this);
        this.pushListener({ event: 'click', element: this.increaser, action: onIncrease });
    }

    amountChange() {
        if (!this.counter) return;
        const { step, max, value } = this.counter;
        const valueNumber = Number(value);
        if (Number(max) !== 0 && valueNumber >= Number(max)) {
            this.counter.value = String(max);
        }
    }

    increase() {
        if (!this.counter || !this.increaser) return;
        const { step, max, value } = this.counter;
        const valueNumber = Number(value);
        if (Number(max) !== 0 && valueNumber >= Number(max)) return;
        this.counter.value = String(valueNumber + (Number(step) || 1));
    }

    decrease() {
        if (!this.counter || !this.decreaser) return;
        const { step, min, value } = this.counter;
        const valueNumber = Number(value);
        if (valueNumber <= (Number(min) || 1)) return;
        this.counter.value = String(valueNumber - (Number(step) || 1));
    }

    registerEventListener() {
        this.pushListener({
            event: 'submit',
            element: this.formular!,
            action: this.submitForm.bind(this),
        });
        this.quantityField?.addEventListener('focus', (event) => {
            setTimeout(() => {
                this.quantityField?.select();
            }, 0);
        });
    }

    submitForm(event: Event): void {
        const isQuickAdd = this.closest('.tk-quick-order') || undefined;
        if (isQuickAdd) {
            event.preventDefault();
            this.submitFormQuickAddAsync();
        }
        console.log('submit');
    }

    submitFormQuickAddAsync(): void {
        const payload = {
            input_dim1: this.quantityField!.value,
        };
        fetchRequest({
            requestURL: this.url!,
            payload,
            resolveHandler: this.handleSuccessQuickAddResponse.bind(this),
        });
    }

    handleSuccessQuickAddResponse(response) {
        if (response && response.dataAsJson.success) {
            sendNotification(NotificationType.SUCCESS, response.dataAsJson.message);
        }
    }

    submitFormAsync(): void {
        const payload = {
            input_dim1: this.quantityField!.value,
        };
        fetchRequest({
            requestURL: this.url!,
            payload,
            resolveHandler: this.handleSuccessResponse.bind(this),
        });
    }

    handleSuccessResponse(response) {
        if (response && response.success) {
            const html = response.dataAsHtml;
            this.innerHTML = html;
        }
    }
}
